import cronstrue from 'cronstrue';

/**
 * Validate a 5-field cron expression in the dialect Hangfire (Cronos) accepts.
 * Returns a human-readable description on success, or an error message string.
 */
export function describeCron(expression: string): { ok: true; text: string } | { ok: false; error: string } {
  const trimmed = expression.trim();
  if (!trimmed) return { ok: false, error: 'Cron expression is required' };
  const fields = trimmed.split(/\s+/);
  if (fields.length !== 5) {
    return {
      ok: false,
      error: `Expected 5 fields (minute hour day-of-month month day-of-week); got ${fields.length}.`,
    };
  }
  try {
    return { ok: true, text: cronstrue.toString(trimmed, { verbose: false }) };
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : 'Invalid cron expression' };
  }
}
